import { render, staticRenderFns } from "./RecentBrandsSection.vue?vue&type=template&id=93adc5d0&lang=pug"
import script from "./RecentBrandsSection.vue?vue&type=script&lang=js"
export * from "./RecentBrandsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports